
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import  ButtonVue from "@/lib/Button.vue";
import UploaderVue from "@/uploader/Uploader.vue";
import { MasterData } from "@/store/MasterData";
import Store from "@/store/Store";
import { IUser } from "@/../../server/src/user/IUser";
import { Finder, IFinder } from "@/finder/IFinder";
import FinderInlineVue from "@/finder/FinderInline.vue";
import { Debouncer } from "@/lib/Debouncer"
import { Searcher } from "./Searcher"
import  ModalVue from "@/Modal.vue";

import  Sqler from "./Sqler.vue"

@Component({ components: { FinderInlineVue, ButtonVue,  ModalVue, Sqler} })
export default class SearcherOrder extends Vue {
    debounced:any;
    key=0;
    async mounted() {
        console.log("Searcher.vue mounted")
        await this.refresh()
    }

   
    created() {
        //bus.register("searcher.handlowiec_selected", this.changed);
    }

    beforeDestroy() {
        //bus.remove("searcher.handlowiec_selected", this.changed);
    }

    async refresh() {
      //this.$emit("searcher_changed",this.searcher);
    }

  
    async debounce() {
        await this.debounced()
    }

}
